import { Button, Input, Select, TableProps } from "antd";
import { useParams } from "react-router-dom";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import StatusItem from "../../../../components/common/StatusItem";
import CustomTable from "../../../../components/ui/CustomTable";
import { AllShiftHistoryParams } from "../../../../features/organization/contractual/JobDetails/jobDetails.type";
import { useGetAllShiftHistoryQuery } from "../../../../features/organization/contractual/JobDetails/jobDetailsApi";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import { formatDate, parseTime } from "../../../../lib/time";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../../utils/utils";
import ManageAssignShift from "./ManageAssignShift";
export const STATUSES = [
  {
    label: "Upcoming",
    value: "upcoming",
    className: "status-link rounded-lg",
  },
  {
    label: "Ongoing",
    value: "ongoing",
    className: "status-warning rounded-lg",
  },
  {
    label: "Completed",
    value: "completed",
    className: "status-success rounded-lg",
  },
];
const ShiftHistory = () => {
  const { id, memberId } = useParams();
  const { open, handleOpen, handleClose } = useModal();
  const {
    page,
    limit,
    filter,
    keyword,
    handleLimit,
    handleSearch,
    handleFilter,
    handlePagination,
  } = useTable<AllShiftHistoryParams>();

  // --- Query ---
  const { data, isFetching, isLoading } = useGetAllShiftHistoryQuery({
    params: {
      ...filter,
      search: keyword,
      member_id: memberId,
      job_apply_id: Number(id),
    },
  });

  // --- Teble Columns ---
  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Shift Name",
      dataIndex: "shift",
      render: (value) => valueOrNa(value?.shift_name),
    },
    {
      align: "center",
      title: "Date Range",
      render: (record) =>
        `${formatDate(record?.assigned_from, "DD MMM YYYY")} – ${formatDate(
          record?.assigned_to
        )}`,
    },
    {
      align: "center",
      title: "Time",
      dataIndex: "shift",
      render: (value) => {
        const startTime = parseTime(value?.shift_start_time);
        const endTime = parseTime(value?.shift_end_time);
        return `${startTime}–${endTime}`;
      },
    },
    {
      align: "center",
      title: "Effective Date",
      dataIndex: "effective_date",
      render: (val) => formatDate(val),
    },
    {
      align: "center",
      title: "Present",
      dataIndex: "attendance_summary",
      render: (val) => addCommaInNumber(val?.present || 0),
    },
    {
      align: "center",
      title: "Absent",
      dataIndex: "attendance_summary",
      render: (val) => addCommaInNumber(val?.absent || 0),
    },
    {
      align: "center",
      title: "Late",
      dataIndex: "attendance_summary",
      render: (val) => addCommaInNumber(val?.late || 0),
    },
    {
      align: "center",
      title: "Total days",
      dataIndex: "total_days_assigned",
      render: (val) => addCommaInNumber(val || 0),
    },
    {
      align: "center",
      title: "Status",
      dataIndex: "computed_status",
      render: (val) => <StatusItem value={val} list={STATUSES} />,
    },
  ];

  return (
    <>
      <CustomTable
        page={page}
        limit={limit}
        columns={columns}
        total={data?.data.total}
        handleLimit={handleLimit}
        loading={isLoading || isFetching}
        handlePagination={handlePagination}
        dataSource={addKeyInArray(data?.data.assignments)}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
              allowClear
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              className="min-w-[90px]"
              rootClassName="icon-gray"
              popupMatchSelectWidth={120}
              suffixIcon={<SelectDownIcon />}
              filterOption={selectSearchOption}
              options={selectArrayOption(STATUSES, "label", "value")}
              onChange={(value) => handleFilter("status", value)}
            />

            <Button
              type="primary"
              color="primary"
              onClick={() => handleOpen({ type: "ADD" })}
            >
              Assign Another Shift
            </Button>
          </>
        }
      />

      <ManageAssignShift
        type={open.type}
        handleClose={handleClose}
        open={open.open && open.type === "ADD"}
      />
    </>
  );
};

export default ShiftHistory;
